/**
 * Collection & search page scripts.
 * - Custom price range slider used by the price facet (snippets/price-facet.liquid).
 */

(function () {
  const SELECTOR = '.custom-price-range';

  function toNumber(value) {
    const parsed = Number(String(value).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function formatPrice(symbol, value) {
    return `${symbol}${Math.round(toNumber(value))}`;
  }

  function getFields(slider) {
    const root = slider.closest('price-range') || slider.parentElement;
    return {
      minRange: slider.querySelector('[data-price-range="min"]'),
      maxRange: slider.querySelector('[data-price-range="max"]'),
      minInput: root?.querySelector('input.field__input[id$="-GTE"]'),
      maxInput: root?.querySelector('input.field__input[id$="-LTE"]'),
      valueLabel: slider.querySelector('[data-price-range-value]'),
      activeTrack: slider.querySelector('[data-price-range-active]'),
      symbol: slider.dataset.currency || '',
      rangeMin: toNumber(slider.dataset.priceMin),
      rangeMax: toNumber(slider.dataset.priceMax),
    };
  }

  function updateSlider(slider) {
    const fields = getFields(slider);
    if (!fields.minRange || !fields.maxRange || fields.rangeMax <= fields.rangeMin) return;

    let minValue = toNumber(fields.minRange.value);
    let maxValue = toNumber(fields.maxRange.value);

    if (minValue > maxValue) {
      if (document.activeElement === fields.minRange) {
        minValue = maxValue;
        fields.minRange.value = String(minValue);
      } else {
        maxValue = minValue;
        fields.maxRange.value = String(maxValue);
      }
    }

    const span = fields.rangeMax - fields.rangeMin;
    const minPercent = ((minValue - fields.rangeMin) / span) * 100;
    const maxPercent = ((maxValue - fields.rangeMin) / span) * 100;

    if (fields.activeTrack) {
      fields.activeTrack.style.left = `${minPercent}%`;
      fields.activeTrack.style.width = `${Math.max(maxPercent - minPercent, 0)}%`;
    }

    if (fields.valueLabel) {
      fields.valueLabel.textContent = `${formatPrice(fields.symbol, minValue)} - ${formatPrice(
        fields.symbol,
        maxValue
      )}`;
    }

    if (fields.minInput) {
      fields.minInput.value = minValue > fields.rangeMin ? String(minValue) : '';
    }

    if (fields.maxInput) {
      fields.maxInput.value = maxValue < fields.rangeMax ? String(maxValue) : '';
    }
  }

  function initSlider(slider) {
    if (slider.dataset.priceSliderReady === 'true') return;
    slider.dataset.priceSliderReady = 'true';
    updateSlider(slider);
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initSlider);
  }

  document.addEventListener(
    'input',
    (event) => {
      if (!event.target.matches?.(`${SELECTOR} input[type="range"]`)) return;
      const slider = event.target.closest(SELECTOR);
      if (slider) updateSlider(slider);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches(SELECTOR)) {
          initSlider(node);
        } else if (node.querySelector?.(SELECTOR)) {
          initAll(node);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
